import { render, staticRenderFns } from "./CatalogSettings.vue?vue&type=template&id=1df4ab5a&scoped=true"
import script from "./CatalogSettings.vue?vue&type=script&lang=js"
export * from "./CatalogSettings.vue?vue&type=script&lang=js"
import style0 from "./CatalogSettings.vue?vue&type=style&index=0&id=1df4ab5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4ab5a",
  null
  
)

export default component.exports